import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { bonuses, offerIncludes } from '../data/content';
import { CtaButton } from './CtaButton';
import { ProductCollage } from './ProductCollage';
import { BonusFan } from './BonusFan';
import { PrintCutShare } from './PrintCutShare';
import { SunRays } from './decor/SunRays';
export function FinalOffer() {
  return <section id="offer" aria-labelledby="offer-title" className="relative overflow-hidden bg-cream-deep" data-id="element-97" data-mp="1ch6bprl0bn30">
      <SunRays className="pointer-events-none absolute -right-40 -top-40 w-[560px] text-gold/20" data-id="element-98" data-mp="1lfi1xshyoiux" />
      <div className="relative mx-auto max-w-content px-5 py-20 sm:px-8 lg:py-28" data-id="element-99" data-mp="204eheamcky5k">
        <h2 id="offer-title" className="mx-auto max-w-3xl text-balance text-center font-display text-[40px] leading-[1.04] text-navy sm:text-[58px]" data-id="element-100" data-mp="2067h15yjmi42">
          Get the Complete Gospel Sharing Mega Bundle Today
        </h2>

        <div className="mt-14 space-y-6" data-id="element-101" data-mp="2469k9jjxfjlg">
          <ProductCollage data-id="element-102" data-mp="247knni9gmpc1" />
          <BonusFan data-id="element-103" data-mp="24455u7oej26x" />
        </div>

        <div className="mx-auto mt-12 grid max-w-5xl overflow-hidden rounded-3xl bg-white shadow-sheet ring-2 ring-coral/25 md:grid-cols-[1.2fr_1fr]" data-id="element-104" data-mp="1pypv3pqnxlv">
          <div className="p-7 sm:p-9" data-id="element-105" data-mp="6qmgvpdyweg3">
            <p className="text-xs font-extrabold uppercase tracking-[0.14em] text-coral-deep" data-id="element-106" data-mp="bn3h3hyfyj9j">Your digital bundle includes:</p>
            <ul className="mt-5 space-y-3" data-id="element-107" data-mp="gnr8i4ql124a">
              {offerIncludes.map(item => <li key={item} className="flex items-start gap-3 font-bold text-navy" data-id="element-108" data-mp="kn9r2tuxl13y">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-leaf-deep" strokeWidth={3} aria-hidden="true" data-id="element-109" data-mp="pmmcda65m04f" />
                  {item}
                </li>)}
            </ul>
            <p className="mt-8 text-xs font-extrabold uppercase tracking-[0.14em] text-gold-deep" data-id="element-110" data-mp="zdqps5g6lcx5">Plus 5 bonuses:</p>
            <ul className="mt-4 space-y-3" data-id="element-111" data-mp="14dbocerfvj9c">
              {bonuses.map(b => <li key={b.number} className="flex items-start gap-3 font-bold text-navy" data-id="element-112" data-mp="18ddqep136ep5">
                  <GiftIcon className="mt-0.5 h-5 w-5 shrink-0 text-coral" aria-hidden="true" data-id="element-113" data-mp="35e05bqgp5yqm" />
                  {b.name}
                </li>)}
            </ul>
          </div>

          <div className="flex min-w-0 flex-col items-center justify-center bg-cream px-5 py-8 text-center sm:p-9" data-id="element-114" data-mp="3e6lb85z8cay1">
            <p className="text-sm font-extrabold uppercase tracking-[0.12em] text-ink-mute" data-id="element-115" data-mp="39fv52qizc42a">
              Total value <span className="line-through decoration-coral decoration-2" data-id="element-116" data-mp="3o4811ni2hmws">$97</span>
            </p>
            <p className="mt-2 text-sm font-extrabold uppercase tracking-[0.14em] text-navy" data-id="element-117" data-mp="3j6pv85zcjnt0">Today: only</p>
            <p className="font-display text-[80px] leading-[0.95] text-coral sm:text-[96px]" data-id="element-118" data-mp="za15o57g161">$27</p>
            <p className="mt-3 max-w-[18rem] text-balance text-sm font-semibold leading-relaxed text-ink-soft" data-id="element-119" data-mp="3t55i1wrccawp">
              One-time payment · No subscription · Instant digital access
              <span className="block" data-id="element-120" data-mp="1yquxi0hs42wq">Free updates for life.</span>
            </p>
            <CtaButton checkout block className="mt-6" data-id="element-121" data-mp="1olmk3qr56e00">
              Get the Complete Bundle Now
            </CtaButton>
            <p className="mt-5 text-xs font-extrabold uppercase tracking-[0.14em] text-navy" data-id="element-122" data-mp="1smokiawsow3k">200+ Bible verses • 20+ designs</p>
            <div className="mt-3" data-id="element-123" data-mp="1ew318l3fik55">
              <PrintCutShare data-id="element-124" data-mp="1jvfv3pspwrh8" />
            </div>
            <p className="mt-3 font-display text-xl italic text-leaf-deep" data-id="element-125" data-mp="1ju4s3s73jnr6">Start planting Gospel seeds today.</p>
          </div>
        </div>
      </div>
    </section>;
}